import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

function LoginModal({ show, onHide }) {
    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>로그인 필요</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                이 기능을 사용하려면 로그인이 필요합니다.
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    닫기
                </Button>
                <Button variant="primary" as={Link} to="/login" onClick={onHide}>
                    로그인하기
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default LoginModal;
